import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { EnumDescriptor } from '../../enum-descriptor';
import { Operation } from 'src/app/proxy/integrations-status';

@Component({
  selector: 'app-operation-dropdown',
  standalone: false,
  templateUrl: './operation-dropdown.component.html',
})
export class OperationDropdownComponent extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;
  @Input() operationSelected: EnumDescriptor;
  @Input() isDisabled = false;

  @Output() changeSelectedOperation = new EventEmitter<EnumDescriptor | undefined>();
  operations: EnumDescriptor[];
  selectedOperation: EnumDescriptor | undefined;

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    this.loadOperations();
    this.onSelected();
  }

  loadOperations(): void {
    this.operations = this.getEnumOptions(Operation, false);
  }

  setSelectedState(value: EnumDescriptor | undefined): void {
    this.selectedOperation = value;
    this.onSelected();
  }

  onSelected(): void {
    this.changeSelectedOperation.emit(this.selectedOperation);
  }
}